<template>
    <Teleport to="body">
        <div class="modal fade z:$(comment-modal-zindex)! {content:'';fixed:z:$(comment-modal-overlay-zindex);bg:#0000001A;top:0;left:0;w:full;h:full}::before" ref="root" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title f:20!">切換留言身份</h3>
                        <button class="btn-close" data-bs-dismiss="modal" type="button"></button>
                    </div>
                    <div class="modal-body p:24!">
                        <div class="mb:16">選擇留言身份，以其他的身份在貼文互動。</div>
                        <div class="{p:8|12;flex;ai:center;gap:16}>div {font:bold}>div_.row-label">
                            <div v-if="userInfo.college_name">
                                <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ userInfo.college_name }}</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="checkbox" v-model="isCollege1" />
                                </div>
                            </div>
                            <div v-if="userInfo.college2_name">
                                <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ userInfo.college2_name }}</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="checkbox" v-model="isCollege2" />
                                </div>
                            </div>
                            <div v-if="userInfo.college3_name">
                                <img alt="" class="w:32" src="asset/image/avatar-college.svg" />
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ userInfo.college3_name }}</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="checkbox" v-model="isCollege3" />
                                </div>
                            </div>
                            <div>
                                <member-avatar :icon-url="userInfo.avatar_url" :short-name="userInfo.short_name"></member-avatar>
                                <div class="flex ai:center gap:16 flex:1">
                                    <span class="row-label">{{ userInfo.name }}</span>
                                </div>
                                <div>
                                    <input class="form-check-input" type="checkbox" v-model="isName" />
                                </div>
                            </div>
                            <template v-if="userInfo.nickname">
                                <div class="mb:68@sm {flex-wrap:wrap}@<sm" v-if="inEdit">
                                    <img alt="" class="w:32" src="asset/image/avatar-nickname.svg" />
                                    <div class="flex ai:center gap:16 {order:2;flex:1}@<sm">
                                        <span class="row-label">暱稱</span>
                                    </div>
                                    <div class="{flex:1}@sm rel {order:4;w:full;mb:24}@<sm">
                                        <input class="form-control {max-w:327}@sm w:full" :class="{ success: checked, 'error-border': error === 'error.nickname-required' }" placeholder="輸入暱稱" v-model.trim="nickname" />
                                        <div class="error-msg-area mt:8 {abs;top:100%}@sm">
                                            <div class="error-msg" :class="{ error: error === 'error.nickname-length' }">最長10字中英字元</div>
                                            <div class="error-msg" :class="{ error: error === 'error.nickname-exists' }">不可與他人重複</div>
                                            <div class="error-msg" :class="{ error: error === 'error.irregular-nickname' }">不可包含 OPT、歐趴糖 字串</div>
                                        </div>
                                    </div>
                                    <div class="{order:3}@<sm">
                                        <button class="inline-block b:0 p:8|12 r:8 bg:white color:#5E6472" @click="setEditMode(false)" type="button">取消</button>
                                        <button class="inline-block b:0 p:8|12 r:8 bg:#EEF3FB color:primary {bg:#CECECE;color:#6F737D}:disabled" @click="saveNickname" :disabled="nickname === userInfo.nickname" type="button">確認</button>
                                    </div>
                                </div>
                                <div class="{flex-wrap:wrap}@<sm" v-else>
                                    <img alt="" class="w:32" src="asset/image/avatar-nickname.svg" />
                                    <div class="flex ai:center gap:16 {order:2;flex:1}@<sm">
                                        <span class="row-label">暱稱</span>
                                    </div>
                                    <div class="{flex:1}@sm rel {order:4;w:full;mb:24}@<sm">
                                        <div class="flex ai:center">
                                            <input class="form-control {max-w:327}@sm w:full" readonly placeholder="輸入暱稱" v-model="userInfo.nickname" />
                                            <button class="inline-block w:20 h:20 bg:url('image/icon_pen.svg') ml:8" @click="setEditMode(true)" type="button"></button>
                                        </div>
                                    </div>
                                    <div class="{order:3}@<sm">
                                        <input class="form-check-input" type="checkbox" v-model="isNickname" />
                                    </div>
                                </div>
                            </template>
                            <div class="mb:68@sm {flex-wrap:wrap}@<sm" v-else>
                                <img alt="" class="w:32" src="asset/image/avatar-nickname.svg" />
                                <div class="flex ai:center gap:16 {order:2;flex:1}@<sm">
                                    <span class="row-label">暱稱</span>
                                </div>
                                <div class="flex:1@sm rel {order:4;w:full;mb:24}@<sm">
                                    <input class="form-control {max-w:327}@sm w:full" :class="{ success: checked, 'error-border': error === 'error.nickname-required' }" placeholder="輸入暱稱" v-model="nickname" />
                                    <div class="error-msg-area mt:8 {abs;top:100%}@sm">
                                        <div class="error-msg" :class="{ error: error === 'error.nickname-length' }">最長10字中英字元</div>
                                        <div class="error-msg" :class="{ error: error === 'error.nickname-exists' }">不可與他人重複</div>
                                        <div class="error-msg" :class="{ error: error === 'error.irregular-nickname' }">不可包含 OPT、歐趴糖 字串</div>
                                    </div>
                                </div>
                                <div class="{order:3}@<sm">
                                    <button class="inline-block b:0 p:8|12 r:8 bg:#EEF3FB color:primary {bg:#CECECE;color:#6F737D}:disabled" @click="saveNickname" :disabled="!nickname" type="button">
                                        <i class="fa-solid fa-plus"></i> 新增
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <div class="w:full flex jc:center gap:24">
                            <button class="btn btn-outline-secondary color:gray03" @click="cancelHandler" type="button">取消</button>
                            <button class="btn btn-primary" @click="submitHandler" type="button">確認</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const { watchThrottled } = VueUse;

    const userInfo = useUserInfo();

    const type = ref();
    const nickname = ref("");
    const checked = ref(false);
    const error = ref("");
    const inEdit = ref(false);

    const root = ref();

    let modal;

    const isCollege1 = computed({
        get() {
            return type.value === 1;
        },
        set(value) {
            if (value) {
                type.value = 1;
            }
        }
    });

    const isCollege2 = computed({
        get() {
            return type.value === 2;
        },
        set(value) {
            if (value) {
                type.value = 2;
            }
        }
    });

    const isCollege3 = computed({
        get() {
            return type.value === 5;
        },
        set(value) {
            if (value) {
                type.value = 5;
            }
        }
    });

    const isName = computed({
        get() {
            return type.value === 3;
        },
        set(value) {
            if (value) {
                type.value = 3;
            }
        }
    });

    const isNickname = computed({
        get() {
            return type.value === 4;
        },
        set(value) {
            if (value) {
                type.value = 4;
            }
        }
    });

    const cancelHandler = () => {
        emit("cancel");
        hide();
    };

    const emit = defineEmits(["cancel", "submit"]);

    const hide = () => {
        modal.hide();
    }

    const saveNickname = () => {
        error.value = "";

        api("api/member/nickname/save", { nickname: nickname.value }, { prevent: true }).done((res) => {
            if (res.success) {
                userInfo.nickname = nickname.value;
                inEdit.value = false;
            } else {
                error.value = res.error;
            }
        });
    };

    const setEditMode = (flag) => {
        inEdit.value = flag;

        if (flag) {
            nickname.value = userInfo.nickname;
            checked.value = false;
            error.value = "";
        }
    }

    const show = () => {
        type.value = userInfo.type;

        modal.show();
    }

    const submitHandler = () => {
        api("api/member/nickname/change-type", { type: type.value }).done((res) => {
            if (res.success) {
                emit("submit", type.value);
                hide();
            }
        });
    };

    defineExpose({ hide, show });

    onMounted(() => {
        modal = new bootstrap.Modal(root.value);
    });

    watchThrottled(nickname, () => {
        checked.value = false;
        error.value = "";

        if (nickname.value) {
            api("api/member/nickname/check", { nickname: nickname.value }, { prevent: true }).done((res) => {
                if (res.success) {
                    checked.value = true;
                } else {
                    error.value = res.error;
                }
            });
        }
    }, { throttle: 300 });
</script>
